module.exports = {
  white: "#FFFFFF",
  green: "#107c10",
  silver: "#C4C4C4",
  primaryRed: "#EF3D6A",
  promRed1: "#ED5F3C",
  promRed2: "#a80000",
  primaryRedGrayed: "#FB83A1",
  mint: "#DDFFF2",
  promDeepMint: "#65D3A9",
  promGray: "#898989",
  promGray2: "#9B9B9B",
  promGray3: "#E9E9E9",
  promGray4: "#D1D1D1",
  promWhite1: "#F7F7F7",
  promWhite2: "#F0F0F0",
  promBlue1: "#84B2ED",
  promBlack1: "#302F2F",
  promGrey5: "#DADADA",
  promGrey6: "#E5E5E5",
  promBlue2: "#005A9E",
  promLightGreen1: "#A9D08E",
  promLightGreen2: "#C6E0B4",
  promLightGreen3: "#E2EFDA",
  promLightBlue1: "#8EA9DB",
  promLightBlue2: "#B4C6E7",
  promLightBlue3: "#D9E1F2",
};
